export default "// Type your solution below\ntype ship_code = string;\nconst my_ship: ship_code = \"020433\";";